import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-left: 1rem;

  button {
    display: flex;
    align-items: center;
    justify-content: center;

    border: 0;
    background: transparent;

    font-size: 1.2rem;

    cursor: pointer;
  }

  .dropdown-menu {
    right: 0;
    background: var(--white);
    border: 1px solid var(--table-border-color);

    padding: 0.5rem;
    margin-top: 0.5rem;

    box-shadow: var(--table-shadow);

    border-radius: 4px;

    ul {
      width: 100%;
      min-width: 5rem;
      list-style: none;

      li {
        margin-bottom: 0.5rem;
        white-space: nowrap;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
`

export const Column = styled.div`
  display: flex;
  align-items: center;

  & > div {
    flex: initial;
  }

  .checkbox {
    margin-right: 0.5rem;
  }

  .input-info {
    margin: 0;
  }
`
